const primaryMain = '#002664';
const primaryMainOpacity = 'rgba(0, 38, 100, 0.9)';
const secondaryMain = '#847248';
const secondaryMainOpacity = 'rgba(132, 114, 72, 0.5)';
const secondaryLight = '#1f6d50';
const tertiaryMain = '#f8de3f';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
